import {Input, Pipe, PipeTransform} from '@angular/core';
import {ValidationErrors} from '@angular/forms';
import {TranslocoService} from "@ngneat/transloco";
import {getErrorMessage} from "@utility";

@Pipe({
    name: 'errorMessages',
    standalone: false
})
export class ErrorMessagesPipe implements PipeTransform {


  @Input() fromControlName?: string;

  constructor(private transloco: TranslocoService) {
  }

  transform(errors: ValidationErrors | null, key?: string, displayAll: boolean = false): string[] {
    return getErrorMessage(errors, this.transloco, key, displayAll);
  }
}
